<template>
  <div class="pay-panel fixed-pay-panel">
    <ConfirmModal ref="confirmModal"></ConfirmModal>

    <div class="content">
      <div class="merchant-row">
        <div class="merchant-avatar" :class="{ 'is-channel': !!channelIcon }" style="display: flex;align-items: center;justify-content: center;">
          <img :src="merchantAvatar" alt="" />
        </div>
        <div class="merchant-name">{{ merchantName }}</div>
      </div>

      <div class="amount-card">
        <div class="amount-label">付款金额</div>
        <div class="amount-line">
          <span class="amount-symbol">￥</span>
          <div class="input-c fixed-amount-value">
            <div class="input-c-div-1">{{ formatMoney(amount) }}</div>
          </div>
        </div>
        <div v-if="orderSubject" class="fixed-order-subject">{{ orderSubject }}</div>
        <div class="remark-input" @click="myDialogStateFn(remark)">
          <span v-if="remark">{{ remark }}</span>
          <span v-else>添加备注</span>
        </div>
      </div>

      <div class="brand-logo">
        <img
          class="brand-logo-img"
          src="https://agent.fskeeper.com/img/乘鱼掌柜（黑色字体）.png"
          alt="乘鱼掌柜"
        />
      </div>
    </div>

    <MyDialog
      v-show="myDialogState"
      @myDialogStateFn="myDialogStateFn"
      :remark="remark"
      :typeColor="themeColor"
    />

    <div class="bnt-pay fixed-pay-actions">
      <div class="bnt-pay-group">
        <div
          class="bnt-pay-text"
          :style="'background:' + themeColor + ';'"
          @click="pay"
        >
          付款
        </div>
        <div
          v-if="invoiceEnabled"
          class="bnt-pay-text-outline"
          :style="'color:' + themeColor + ';border-color:' + themeColor + ';'"
          @click="payAndInvoice"
        >
          付款+开票
        </div>
      </div>
    </div>

    <div v-if="paying" class="pay-loading-mask">
      <div class="pay-loading-box">
        <div class="pay-loading-spinner" :style="'border-top-color:' + themeColor + ';'"></div>
        <div class="pay-loading-text">处理中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import MyDialog from '../dialog/dialog'
import { getPayPackage, getPayOrderInfo, cancelPay } from '@/api/api'
import config from '@/config'
import wayCodeUtils from '@/utils/wayCode'
import channelAvatar from '@/mixins/channelAvatar'

const PAY_META = {
  wxpay: {
    payType: 'wxpay',
    payLabel: '微信支付',
    payImg: require('../../assets/icon/wx.svg'),
    color: '#07c160'
  },
  alipay: {
    payType: 'alipay',
    payLabel: '支付宝支付',
    payImg: require('../../assets/images/zfb.jpeg'),
    color: '#1678ff'
  },
  ysfpay: {
    payType: 'ysfpay',
    payLabel: '云闪付支付',
    payImg: require('../../assets/images/ysf.jpg'),
    color: '#ff534d'
  }
}

export default {
  components: { MyDialog },
  mixins: [channelAvatar],
  data() {
    const meta = PAY_META[this.$route.meta.payType] || PAY_META.wxpay
    return {
      payType: meta.payType,
      payLabel: meta.payLabel,
      payImg: meta.payImg,
      themeColor: meta.color,
      merchantName: '',
      amount: '',
      orderSubject: '',
      payOrderInfo: {},
      resData: {},
      myDialogState: false,
      remark: '',
      paying: false,
      invoiceEnabled: false,
      fromInvoice: false,
      // 商户推广引流：抖音/快手/小红书链接拼接文案，下单（点付款手势）时复制到剪贴板
      promoCopyText: ''
    }
  },
  mounted() {
    this.fromInvoice = this.$route.query.fromInvoice === '1'
    this.loadPayOrderInfo()
  },
  methods: {
    loadPayOrderInfo() {
      const that = this
      getPayOrderInfo().then(res => {
        if (!res.payOrderId) {
          const routeName = wayCodeUtils.getPayWay()?.routeName
          if (routeName) {
            that.$router.replace({ name: routeName })
          }
          return
        }
        that.payOrderInfo = res
        that.bindChannelAvatar(res)
        that.merchantName = res.mchName
        that.promoCopyText = that.buildPromoCopyText(res.promotion)
        that.amount = ((res.amount || 0) / 100) + ''
        that.orderSubject = res.subject || ''
        that.invoiceEnabled = !!res.invoiceEnabled
        if (that.fromInvoice) {
          that.pay()
        }
      }).catch(res => {
        that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
      })
    },
    formatMoney(money) {
      if (!money && money !== 0) return '0.00'
      const part = money.toString().split('.')
      const l = part[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      const r = part.length > 1 ? `.${part.pop()}` : ''
      return `${l}${r}`
    },
    myDialogStateFn(remark) {
      this.remark = remark
      this.myDialogState = !this.myDialogState
    },
    payAndInvoice() {
      this.goInvoicePage()
    },
    goInvoicePage() {
      this.$router.push({
        name: 'CashierInvoice',
        query: { amount: this.amount, payType: this.payType, remark: this.remark }
      })
    },
    buildPromoCopyText(promo) {
      if (!promo) return ''
      const parts = []
      if (promo.douyinVideoUrl) parts.push('抖音：' + promo.douyinVideoUrl)
      if (promo.kuaishouVideoUrl) parts.push('快手：' + promo.kuaishouVideoUrl)
      if (promo.xiaohongshuVideoUrl) parts.push('小红书：' + promo.xiaohongshuVideoUrl)
      return parts.join('\n')
    },
    copyToClipboard(text) {
      if (!text) return Promise.resolve()
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text))
      }
      return Promise.resolve(this.fallbackCopy(text))
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand('copy') } catch (e) { /* ignore */ }
      document.body.removeChild(ta)
    },
    pay() {
      if (this.paying) return
      const that = this
      this.paying = true
      // 在用户点击「付款」的手势上下文中复制推广链接（此时剪贴板写入最可靠），
      // 支付完成后用户即可直接到抖音/快手/小红书粘贴打开。
      if (this.promoCopyText) {
        this.copyToClipboard(this.promoCopyText)
      }
      getPayPackage(this.amount, this.remark).then(res => {
        that.paying = false
        if (res.code && res.code != '0') {
          return that.$confirm({ title: '请求失败', content: res.msg, typeColor: that.themeColor });
        }
        if (res.orderState != 1) {
          return that.$confirm({ title: '订单异常', content: res.errMsg || '订单状态异常', typeColor: that.themeColor });
        }
        that.resData = res
        if (that.payType === 'wxpay') {
          that.invokeWxPay(res)
        } else if (that.payType === 'alipay') {
          that.invokeAlipay(res.alipayTradeNo)
        } else if (that.payType === 'ysfpay') {
          that.invokeYsfPay(res)
        }
      }).catch(res => {
        that.paying = false
        that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
      })
    },
    showCancelResult(data, close) {
      if (data && data.paid) {
        this.$confirm({ title: '提示', content: '支付已完成', typeColor: this.themeColor, onOk: close });
        return;
      }
      if (data && data.pending) {
        this.$confirm({
          title: '支付结果确认中',
          content: '支付结果尚未确定，请稍后查看订单，请勿重复支付。',
          typeColor: this.themeColor,
          onOk: close
        });
        return;
      }
      this.$confirm({ title: '提示', content: '支付已取消', typeColor: this.themeColor, onOk: close });
    },
    handleWxPayCancel() {
      const close = () => window.WeixinJSBridge.call('closeWindow');
      cancelPay(this.resData.payOrderId).then(data => {
        this.showCancelResult(data, close);
      }).catch(() => {
        this.$confirm({
          title: '支付结果确认中',
          content: '支付结果尚未确定，请稍后查看订单，请勿重复支付。',
          typeColor: this.themeColor,
          onOk: close
        });
      })
    },
    handleAlipayCancel() {
      const close = () => window.AlipayJSBridge.call('closeWebview');
      cancelPay(this.resData.payOrderId).then(data => {
        this.showCancelResult(data, close);
      }).catch(() => {
        this.$confirm({
          title: '支付结果确认中',
          content: '支付结果尚未确定，请稍后查看订单，请勿重复支付。',
          typeColor: this.themeColor,
          onOk: close
        });
      })
    },
    invokeWxPay(res) {
      const that = this
      const onReady = () => {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          JSON.parse(res.payInfo),
          function (payRes) {
            if (payRes.err_msg === 'get_brand_wcpay_request:ok') {
              if (that.payOrderInfo.returnUrl) {
                location.href = that.payOrderInfo.returnUrl
              } else {
                that.$confirm({
                  title: '支付成功',
                  content: '支付已完成',
                  typeColor: that.themeColor,
                  onOk: () => window.WeixinJSBridge.call('closeWindow')
                });
              }
            } else if (payRes.err_msg === 'get_brand_wcpay_request:cancel') {
              that.handleWxPayCancel()
            } else {
              that.$confirm({
                title: '支付失败',
                content: JSON.stringify(payRes),
                typeColor: that.themeColor,
                onOk: () => window.WeixinJSBridge.call('closeWindow')
              });
            }
          }
        )
      }
      if (typeof WeixinJSBridge === 'undefined') {
        document.addEventListener('WeixinJSBridgeReady', onReady, false)
      } else {
        onReady()
      }
    },
    invokeAlipay(alipayTradeNo) {
      const that = this
      const doPay = () => {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('tradePay', { tradeNO: alipayTradeNo }, function (data) {
          if (data.resultCode === '9000') {
            if (that.payOrderInfo.returnUrl) {
              location.href = that.payOrderInfo.returnUrl
            } else {
              that.$confirm({
                title: '支付成功',
                content: '支付已完成',
                typeColor: that.themeColor,
                onOk: () => window.AlipayJSBridge.call('closeWebview')
              });
            }
          } else if (data.resultCode === '6001') {
            that.handleAlipayCancel()
          } else {
            that.$confirm({
              title: '支付结果',
              content: JSON.stringify(data),
              typeColor: that.themeColor,
              onOk: () => window.AlipayJSBridge.call('closeWebview')
            });
          }
        })
      }
      if (!window.AlipayJSBridge) {
        document.addEventListener('AlipayJSBridgeReady', doPay, false)
      } else {
        doPay()
      }
    },
    invokeYsfPay(res) {
      if (res.redirectUrl) {
        window.location.href = res.redirectUrl
      } else {
        this.$confirm({ title: '无法跳转', content: '支付跳转地址为空', typeColor: this.themeColor });
      }
    }
  }
}
</script>

<style lang="css" scoped>
@import './pay.css';

.fixed-pay-panel {
  padding-bottom: 4rem;
}

.fixed-pay-panel .amount-card {
  height: auto;
  min-height: 4.08rem;
  padding-bottom: 0.12rem;
}

.fixed-amount-value {
  width: auto !important;
  flex: 1;
  color: #111;
}

.fixed-amount-value .input-c-div-1 {
  font-size: 0.88rem;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
}

.fixed-order-subject {
  margin-top: 0.12rem;
  font-size: 0.34rem;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-pay-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.32rem 0.4rem calc(0.32rem + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.pay-loading-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.pay-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 28px 36px;
  gap: 14px;
}
.pay-loading-spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #e0e0e0;
  border-radius: 50%;
  animation: pay-spin 0.8s linear infinite;
}
.pay-loading-text {
  font-size: 14px;
  color: #555;
}
@keyframes pay-spin {
  to { transform: rotate(360deg); }
}
</style>
